$.arcticmodal('setDefault', {
    modal: false,
    closeOnEsc: false,
    openEffect: {
        type: 'none'
    },
    closeEffect: {
        type: 'none'
    },
    fixed: '.header__top',
    closeOnOverlayClick: true
});

/**
 * Инициализация хелпера
 */
$(function(){
    $$.$body = $('body');

    $$.isMobile && $('html').addClass('is-mobile');

    var init = {
        fastclick: function (){
            $$.$body.find('a, button, input').on('touchstart', function (){});
        },
        sticky: function (context){
            if ( $$.isMobile || !$.fn.Stickyfill ) return;
            $('.sticky', context).Stickyfill();
        },
        popup: function (context){
            Helper.bindPopup($('[js-open-popup]', context));
        },
        modal: function (context){
            Helper.bindModal($('[js-open-modal]', context));
        },
        tabs: function (){
            Helper.createTabs();
        },
        formPlugins: function (context) {
            $('[js-selectus]', context).selectus();
            $('[js-input]', context).inputShadow();

            $('[js-input-files]', context).inputFile();

            $('[js-input-disabled]', context).each(function(key, item){
                $$.blockOverlay($(item).parent());
            });

            $('[js-form]', context).formHandle({
                beforeData: function ($form) {},
                afterData: function () {},
                success: function (data, $form) {

                    //отправка данных формы в Comagic
                    if (typeof(Comagic) !== "undefined"){
                        let $objFields = {name:'', email:'', phone:'', message:''};
                        let $club = '';
                        $form.find ('input').each(function() {
                            if(this.name === 'field_93' || this.name === 'field_25' || this.name === 'field_96' || this.name === 'field_7' || this.name === 'field_11' || this.name === 'field_30' || this.name === 'field_3'){
                                $objFields.name = $(this).val();
                            }
                            if(this.name === 'field_2' || this.name === 'field_26' || this.name === 'field_97' || this.name === 'field_8' || this.name === 'field_12' || this.name === 'field_31'|| this.name === 'field_4'){
                                $objFields.phone = $(this).val();
                            }
                            if(this.name === 'field_6' || this.name === 'field_98'|| this.name === 'field_10' || this.name === 'field_35'){
                                $objFields.email = $(this).val();
                            }
                            if(this.name === 'field_27'){
                                if($(this).val() === 1){
                                    $club = 'vzlet';
                                }else{
                                    $club = 'plaza';
                                }
                            }
                        });
                        let $title = $(document).find("title").text();
                        let $href = window.location.href;
                        let $device = ( $$.isMobile ) ? 'мобильное' : 'десктоп';
                        $objFields.message += 'Клуб: ' + $club + ' | ';
                        // $objFields.message += 'Тема заявки: ' + value + ' | ';
                        // $objFields.message += 'Тип формы: ' + value + ' | ';
                        $objFields.message += 'Устройство: ' + $device + ' | ';
                        $objFields.message += 'Страница: ' + $title + '| ';
                        $objFields.message += 'URL: ' + $href;
                        if(typeof(Comagic.addOfflineRequest) !== "undefined"){
                            Comagic.addOfflineRequest($objFields)
                        }
                    }

                    if (data.clear_form) {
                        $form.resetForm();
                    }
                    if (data.alert) {
                        $$.openModal($('<div class="window__bg window__bg_odd"></div><h1>' + data.alert + '</h1>')).addClass('window');
                    } else {
                        $form.closest('div').slideUp(function(){
                            $form.closest('div').html('<div class="form__success">'+(data.success_text ? data.success_text : data.message)+'</div>').slideDown();
                        });


                        if(typeof yaCounter19425832  != 'undefined'){
                            var goal = 'lead';
                            yaCounter19425832.reachGoal(goal, null, function(){
                                console.log('goal: '+goal);
                            });
                        }
                    }

                    if (data.redirect) {
                        if (data.alert) setTimeout(function () {document.location.href = data.redirect;}, 1500);
                        else document.location.href = data.redirect;
                    }
                    setTimeout(function () {
                        $.arcticmodal('close');
                    },2500)
                }.bind(this)
            });

            this.phoneMask(context);
            this.inputmask(context);
        },
        inputmask: function(context){
            $('[data-inputmask]', context).inputmask();
        },
        phoneMask: function(context){
            $('[data-masked="phone"]', context).inputmask("+7(999)-999-9999", {showMaskOnHover: false});
        }
    };

    init.all = function (context){
        $$.init.formPlugins();
        $$.init.modal();
    };
    $$.init = init;

    $$.init.all();
});
